module.exports = __webpack_public_path__ + "img/step53_a_printer_power_remove_packaging.b3dbf936.png";